import React from 'react';

import { Grid, Typography } from '@mui/material';

export interface NativeTourEntry {
  label: string;
  value: string | null | undefined;
}

/** Read-only labelled values in a grid. */
export default function NativeTourEntries({ entries }: { entries: Array<NativeTourEntry> }) {
  return (
    <Grid container spacing={2}>
      {entries.map(({ label, value }) => (
        <Grid key={label} size={{ xs: 12, sm: 6, md: 4 }}>
          <Typography variant="caption" color="text.secondary">
            {label}
          </Typography>
          <Typography whiteSpace="pre-wrap" color={value ? 'text.primary' : 'text.disabled'}>
            {value || 'Not set'}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
}
